import {
  LIST_INTAKE_FAILED,
  LIST_INTAKE_REQ,
  LIST_INTAKE_SUCCESS,
} from "../Constants/intakeConstant";

export const INTAKE_LIST_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case LIST_INTAKE_REQ: {
      return { Intake_List_Loading: true };
    }

    case LIST_INTAKE_SUCCESS: {
      return { Intake_List_Loading: false, Intake_List: payload };
    }
    case LIST_INTAKE_FAILED: {
      return { Intake_List_Loading: false, Intake_List_Error: payload };
    }

    default:
      return state;
  }
};
